import {
  Paper,
  Table,
  Typography,
  TableCell,
  TableHead,
  TableBody,
  TableRow,
  TableContainer,
  Grid,
} from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { Module } from '../@types/user';
import Breadcrumbs from '../components/common/Breadcrumbs';
import { BreadcrumbsLink } from '../components/common/Breadcrumbs/Breadcrumbs';
import MainLayout from '../components/MainLayout';
import { ROLE } from '../enums/role';
import withAuth from '../hocs/withAuth';
import withRoles from '../hocs/withRoles';
import ModuleService from '../services/module.service';

const links: BreadcrumbsLink[] = [
  {
    label: 'Dashboard',
    href: '/dashboard',
  },
  {
    label: 'Management',
    href: '/management/modules',
  },
  {
    label: 'Modules',
  },
];
const Modules = () => {
  const [modules, setModules] = useState<Module[]>([]);

  const getAllModule = async () => {
    const { modules } = await ModuleService.getAllModule();
    if (modules) {
      setModules(modules);
    }
  };

  useEffect(() => {
    getAllModule();
  }, []);
  return (
    <MainLayout>
      <Grid container justify="center">
        <Grid item xs={12} sm={8} md={6}>
          <Breadcrumbs links={links} />
          <Typography variant="h5" color="textPrimary" className="font-bold mt-2">
            All Modules
          </Typography>
          <Paper className="mt-5" elevation={1}>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Key</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {modules.map((module) => (
                    <TableRow key={module.id}>
                      <TableCell component="th" scope="row">
                        {module.name}
                      </TableCell>
                      <TableCell className="uppercase">{module.key}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
      </Grid>
    </MainLayout>
  );
};

export default withAuth(withRoles(Modules, [ROLE.SUPER_ADMIN, ROLE.ADMIN, ROLE.MANAGER]), '/login');
